import { takeLatest, call, put, select } from 'redux-saga/effects';
import {
  requestInProcess,
  requestFinished,
  updateList,
  sendRequest,
  selectQueryParams
} from '../../../../../../common/reducers/list/reducer';
import { timeoutCall } from '../../../../../../utils/sagaHalper';
import UserRatingService from '../../../../services/UserRatingService';

function* userRatingPointsHistorySaga(reducerName) {
  yield put(requestInProcess(reducerName));
  const queryParams = yield select(selectQueryParams, reducerName);
  let status = null;
  try {
    const result = yield call(
      timeoutCall,
      UserRatingService.getAuthUserRatingHistory,
      queryParams
    );
    if (result.response) {
      status = result.response.status;
      if (result.response.status === 200) {
        yield put(
          updateList(reducerName, {
            itemsById: result.destructData.itemsById,
            itemsIds: result.destructData.itemsIds,
            pagination: result.destructData.pagination
          })
        );
      }
    }
  } catch (error) {
    console.log(error);
  }
  yield put(requestFinished(reducerName, status));
}

export default function createSaga(reducerName) {
  return [
    takeLatest(
      sendRequest(reducerName).type,
      userRatingPointsHistorySaga,
      reducerName
    )
  ];
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/userRating/reducers/static/lists/sagas/userRatingPointsHistorySaga.js